<template>
  <v-row class="py-4 home-page">
    <template>
      <global-dialog-card v-model="edit_user_location" title="">
        <v-col cols="12">
          <p class="pa-2 font-weight-bold text-center">
            {{ $t("change_current_location") }}
          </p>
          <div class="text-center">
            <v-row>
              <v-col cols="6">
                <autocomplete
                  :items="countries"
                  item-value="id"
                  item-text="name"
                  v-model="edit_country"
                  :label="$t('country')"
                >
                </autocomplete>
              </v-col>
              <v-col cols="6">
                <autocomplete
                  :items="editCountries"
                  item-value="id"
                  item-text="name"
                  v-model="edit_city"
                  :label="$t('city')"
                >
                </autocomplete>
              </v-col>
            </v-row>
            <input class="guest-input" type="text" v-model="changedUserLocation" />
          </div>
        </v-col>
        <template #actions>
          <primary-button @click="setEditLocation()">
            {{ $t("change") }}
          </primary-button>
        </template>
      </global-dialog-card>
      <global-dialog-card v-model="order_success" :max-width="1000">
        <v-col cols="12">
          <div class="text-center">
            <img
              class="card-img-top success-image"
              width="40%"
              height="40%"
              src="https://app.restorani.bitlab.host/gallery/Frame.jpg"
              alt="Logo"
            />
            <p class="success-text">
              {{ $t("successfully_ordered") }}
            </p>
          </div>
        </v-col>
      </global-dialog-card>
      <global-dialog-card v-model="phone_popup" title="">
        <v-col cols="12">
          <p class="pa-2 font-weight-bold text-center">
            {{ $t("change_phone_number") }}
          </p>
          <div class="text-center">
            <input class="guest-input" type="text" />
          </div>
        </v-col>
        <template #actions>
          <primary-button @click="changePhone()">
            {{ $t("change") }}
          </primary-button>
        </template>
      </global-dialog-card>
      <global-dialog-card v-model="image_popup" :max-width="800" title="">
        <div v-if="mealDesc">
          <img
            v-if="mealDesc.image"
            :key="mealDesc.image_id"
            class="card-img-top"
            width="100%"
            :src="galleryUrl(mealDesc.image.name, 'medium', mealDesc.image.restaurant_id)"
            alt="image"
          />
          <span v-else class="text-center d-block">
            <v-icon class="py-12" small>mdi-image</v-icon>
          </span>
          <div class="image-popup-overlay pa-0">
            <p
              class="text-center mt-2 py-3 mb-0 mx-9"
              style="border-bottom: 1px solid #dcdcdc"
            >
              {{ translate(mealDate) }}.
            </p>
            <h2
              class="text-center mt-2 mx-9 py-1 d-flex justify-space-between align-center"
            >
              <span style="font-size: 15px">
                {{ translate(mealDesc.name) }}
                <span class="meal-description d-block" v-if="mealDesc.description">{{
                  translate(mealDesc.description)
                }}</span>
              </span>
              <span>
                <span v-if="mealDesc.price">
                  {{ mealDesc.price ? formatPrice(mealDesc.price) : 0 }}
                  <span style="font-size: 12px">{{
                    noUserRestoran
                      ? noUserRestoran.restaurant.settings.price
                      : restaurant.settings.price
                  }}</span>
                </span>
              </span>
            </h2>
            <div class="px-9 mt-3">
              <p style="font-size: 12px" class="font-weight-bold">
                {{ $t("contains") }}:
              </p>
              <p v-for="food in mealDesc.foods">- {{ toLatin(food.name) }}</p>
            </div>
            <div class="pb-7 mt-8 mx-4 text-center">
              <div class="qty-controls w-100 mb-4">
                <a
                  @click.prevent="qty(buyListMeal, 'minus', mealDesc.date, buyListShift)"
                  class="qty-btn mr-5"
                >
                  <span class="qty-minus" style="padding: 0 15px; font-size: 27px"
                    >-</span
                  >
                </a>
                <span> {{ buyListMeal.qty ? buyListMeal.qty : 0 }} </span>
                <a
                  @click.prevent="qty(buyListMeal, 'plus', mealDesc.date, buyListShift)"
                  class="qty-btn ml-5"
                >
                  <span class="qty-plus" style="padding: 0 10px; font-size: 27px">+</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <template #actions>
          <primary-button
            @click="addToBuyList(buyListMeal, buyListItem, buyListShift, buyListIndex)"
          >
            {{ $t("order") }}
          </primary-button>
        </template>
      </global-dialog-card>

      <v-row justify="center">
        <v-col class="px-5">
          <v-card-title class="category-nav">
            <aside class="sidebar w-100">
              <div class="sidebar__widget d-flex align-center">
                <a
                  @click.prevent="cat = false"
                  :class="{ 'active-category': cat === false }"
                  class="category-link"
                  style="padding-top: 1px"
                >
                  <span>
                    {{ $t("hot_meals") }}
                  </span>
                </a>
                <a
                  class="cat_link category-link"
                  @click.prevent="changeCategory(category)"
                  :class="{
                    'active-category': category.name === cate.name && cat === true,
                  }"
                  v-for="category in categories"
                >
                  <span>
                    {{ translate(category.name) }}
                  </span>
                </a>
              </div>
            </aside>
          </v-card-title>
          <div class="menu-content-wrapper">
            <div class="w-100" style="padding: 0 10px">
              <template v-for="(item, index) in menues">
                <span
                  style="margin-top: 0"
                  class="d-block"
                  :id="index"
                  :ref="index"
                ></span>
                <div
                  style="display: flex; align-items: center"
                  class="transfer-lista"
                  v-if="
                    $store.state.company &&
                    $store.state.company.parent_id &&
                    user &&
                    user.type != 3 &&
                    user.is_transferable
                  "
                >
                  <label
                    v-if="!item.disabled"
                    class="mb-0 pr-2 text-uppercase font-weight-bold"
                    for=""
                  >
                    {{ $t("lokacija") }}:
                  </label>
                  <autocomplete
                    v-if="!item.disabled"
                    v-model="item.location"
                    :items="locations"
                  >
                  </autocomplete>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="[item]"
                  :items-per-page="-1"
                  class="ordera-box-shadow striped-table"
                  fixed-header
                  hide-default-footer
                  :item-class="rowClass"
                >
                  <template
                    v-for="header in headers"
                    v-slot:[`header.${header.value}`]="{ header }"
                  >
                    <div class="relative">
                      <template v-if="header.value == 'shift_one'"> </template>
                      <template v-else-if="header.value == 'shift_two'"> </template>
                      <template v-else-if="header.value == 'shift_three'">
                        <span
                          class="primary--text"
                          style="
                            font-size: 19px;
                            font-weight: 900;
                            border-bottom: 6px solid;
                            border-radius: 4px;
                          "
                        >
                        </span>
                      </template>
                      <template v-else-if="header.value == 'korpa'">
                        <span
                          class="primary--text"
                          style="
                            font-size: 19px;
                            font-weight: 900;
                            color: rgba(0, 0, 0, 0.87);
                            border-bottom: 6px solid;
                            border-radius: 4px;
                          "
                        ></span>
                      </template>
                    </div>
                  </template>
                  <template
                    v-for="values in headers"
                    v-slot:[`item.${values.value}`]="{ item }"
                  >
                    <!--                    {{ translate(item[values.value]) }}-->
                  </template>
                  <template v-slot:top> </template>
                  <template v-if="cat" v-slot:item.shift_one="{ item, i }">
                    <div class="d-flex flex-wrap pb-16">
                      <p v-if="cate.food == 0" class="py-12">
                        Тренутно нема ништа у понуди...
                      </p>
                      <template
                        v-if="cate.food"
                        v-for="(meal, mealCatIndex) in cate.food"
                      >
                        <div
                          class="meal-card-container"
                          style="width: 25%; height: 250px"
                        >
                          <v-card
                            class="my-1 meal-card w-100"
                            :title="
                              !(item.disabled && item.test != meal.id + '_2-smena')
                                ? ''
                                : $t('change_order_deadline_expired')
                            "
                          >
                            <v-card-title class="pa-0">
                              <v-col class="pa-0">
                                <v-col
                                  v-if="meal.image && meal.image.restaurant_id"
                                  md="12"
                                  class="text-center meal-image-container"
                                  style="height: 140px"
                                >
                                  <img
                                    @click.prevent="
                                      addToBuyList(meal, item, 'shift_one', index)
                                    "
                                    class="card-img-top meal-image"
                                    :key="meal.image_id"
                                    width="100"
                                    :src="
                                      galleryUrl(
                                        meal.image.name,
                                        'medium',
                                        meal.image.restaurant_id
                                      )
                                    "
                                    alt="image"
                                  />
                                </v-col>
                                <v-col
                                  v-if="!meal.image"
                                  md="12"
                                  class="text-center meal-image-container"
                                  style="height: 140px"
                                >
                                  <circle-button
                                    @click="addToBuyList(meal, item, 'shift_one', index)"
                                    :small="false"
                                    icon="mdi-image"
                                  />
                                </v-col>
                                <div>
                                  <v-col
                                    md="12"
                                    :align="'left'"
                                    @click.prevent="
                                      openImage(
                                        meal,
                                        item.name,
                                        item,
                                        'shift_one',
                                        mealCatIndex
                                      )
                                    "
                                  >
                                    <span class="meal-name-text d-block">{{
                                      toLatin(meal.name)
                                    }}</span>
                                  </v-col>
                                  <v-col
                                    md="12"
                                    class="d-flex align-center justify-center"
                                  >
                                    <v-btn
                                      @click.prevent="
                                        addToBuyList(meal, item, 'shift_one', index)
                                      "
                                      :style="
                                        buyingList[item.date] &&
                                        buyingList[item.date].shifts.shift_one.find(
                                          (m) => m.id == meal.id
                                        )
                                          ? 'background:#06B04D !important'
                                          : ''
                                      "
                                      color="primary"
                                      class="order-btn"
                                    >
                                      {{ $t("order") }}
                                      <span v-if="meal.price" class="price-label d-block">
                                        {{ formatPrice(meal.price) }}
                                        {{
                                          $store.state.company
                                            ? $store.state.company.restaurant.settings
                                                .price
                                            : ""
                                        }}
                                      </span>
                                    </v-btn>
                                  </v-col>
                                </div>
                              </v-col>
                            </v-card-title>
                          </v-card>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else v-slot:item.shift_one="{ item, i }">
                    <div id="skrol" class="d-flex flex-wrap pb-16">
                      <template v-for="(meal, mealIndex) in item.shift_one">
                        <div
                          class="meal-card-container"
                          style="width: 25%; height: 215px"
                        >
                          <v-card
                            class="my-1 meal-card fill-height"
                            :title="
                              !(item.disabled && item.test != meal.id + '_1-smena')
                                ? ''
                                : $t('change_order_deadline_expired')
                            "
                          >
                            <v-card-title class="pa-0">
                              <v-row>
                                <v-col>
                                  <div
                                    @click.prevent="
                                      addToBuyList(meal, item, 'shift_one', index)
                                    "
                                    class="text-center meal-image-container"
                                    style="height: 120px"
                                  >
                                    <img
                                      v-if="meal.image && meal.image.restaurant_id"
                                      class="card-img-top meal-image"
                                      @click.prevent="
                                        openImage(
                                          meal,
                                          item.name,
                                          item,
                                          'shift_one',
                                          mealIndex
                                        )
                                      "
                                      :src="
                                        galleryUrl(
                                          meal.image.name,
                                          'original',
                                          meal.image.restaurant_id
                                        )
                                      "
                                      alt="image"
                                    />
                                  </div>
                                  <div
                                    @click.prevent="
                                      openImage(
                                        meal,
                                        item.name,
                                        item,
                                        'shift_one',
                                        mealIndex
                                      )
                                    "
                                    style="
                                      padding: 0 7px;
                                      line-height: 18px;
                                      margin-top: 12px;
                                    "
                                  >
                                    <span
                                      class="meal-name-text w-100 text-left d-block"
                                      >{{ textLimited(translate(meal.name)) }}</span
                                    >
                                  </div>
                                  <v-col
                                    md="12"
                                    class="d-flex align-center justify-center"
                                    style="position: absolute; bottom: -2px"
                                  >
                                    <v-btn
                                      v-if="restaurant"
                                      :disabled="
                                        (item.test !== meal.id + '_1-smena' &&
                                          !!item.test) ||
                                        (!restaurant.settings.guest.rok_dana &&
                                          meal.orders.find(
                                            (order) => order.shift === '1-smena'
                                          ).quantity_payed > 0) ||
                                        (dayTo > item.date && !checkTime)
                                      "
                                      @click.prevent="
                                        addToBuyList(meal, item, 'shift_one', index)
                                      "
                                      color="primary"
                                      :style="
                                        buyingList[item.date] &&
                                        buyingList[item.date].shifts.shift_one.find(
                                          (m) => m.id == meal.id
                                        )
                                          ? 'background:#06B04D !important'
                                          : ''
                                      "
                                      class="order-btn mx-auto mt-auto"
                                    >
                                      {{ $t("order") }}
                                      <span v-if="meal.price"
                                        >({{ formatPrice(meal.price) }}
                                        {{
                                          $store.state.company
                                            ? $store.state.company.restaurant.settings
                                                .price
                                            : ""
                                        }})</span
                                      >
                                    </v-btn>
                                  </v-col>
                                </v-col>
                              </v-row>
                            </v-card-title>
                          </v-card>
                        </div>
                      </template>
                    </div>
                  </template>

                  <template v-slot:item.korpa="{ item, index }">
                    <template>
                      <v-card id="skrol1" class="mb-1 w-100 rounded-xl">
                        <v-card-title>
                          <section class="header w-100" style="min-height: 300px">
                            <div v-if="buyingList[item.date]">
                              <div
                                v-for="(old_meal, inx) in buyingList[item.date].shifts
                                  .shift_one"
                                class="cart-item-row text-left w-100 py-2 d-flex flex-wrap align-content-center"
                              >
                                <div
                                  class="text-left pl-3 w-100 d-flex flex-wrap mb-0 pb-0"
                                  style="font-size: 13px"
                                >
                                  <span
                                    class="d-flex justify-space-between align-center"
                                    style="width: 70%"
                                  >
                                    <span class="cart-item-info">
                                      <span class="text-left cart-item-info d-block">
                                        <span v-if="restaurant" class="cart-item-price">
                                          {{
                                            old_meal.new_price != null
                                              ? formatPrice(old_meal.new_price)
                                              : 0
                                          }}
                                          {{
                                            old_meal.new_price != null
                                              ? restaurant.settings.price
                                              : ""
                                          }}
                                        </span>
                                        <span v-else class="cart-item-price">
                                          {{
                                            old_meal.new_price != null
                                              ? formatPrice(old_meal.new_price)
                                              : 0
                                          }}
                                          {{
                                            old_meal.new_price != null
                                              ? noUserRestoran.restaurant.settings.price
                                              : ""
                                          }}
                                        </span>
                                      </span>
                                      <span class="cart-item-name d-block">{{
                                        old_meal.name
                                      }}</span>
                                    </span>
                                  </span>
                                  <div class="qty-controls" style="width: 30%">
                                    <a
                                      @click.prevent="
                                        qty(old_meal, 'minus', item.date, 'shift_one')
                                      "
                                      class="qty-btn mr-5"
                                    >
                                      <span
                                        class="qty-minus"
                                        style="padding: 0 12px 3px; font-size: 39px"
                                        >-</span
                                      >
                                    </a>
                                    <span> {{ old_meal.qty }} </span>
                                    <a
                                      @click.prevent="
                                        qty(old_meal, 'plus', item.date, 'shift_one')
                                      "
                                      class="qty-btn ml-5"
                                    >
                                      <span
                                        class="qty-plus"
                                        style="padding: 0 10px; font-size: 27px"
                                        >+</span
                                      >
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-for="(old_meal, inx) in buyingList[item.date].shifts
                                  .shift_two"
                                class="cart-item-row text-left w-100 py-2 d-flex flex-wrap align-content-center"
                              >
                                <div
                                  class="text-left pl-3 w-100 d-flex flex-wrap mb-0 pb-0"
                                  style="font-size: 13px"
                                >
                                  <span
                                    class="d-flex justify-space-between align-center"
                                    style="width: 70%"
                                  >
                                    <span class="cart-item-info">
                                      <span class="text-left cart-item-info d-block">
                                        <span class="cart-item-price">
                                          {{
                                            old_meal.new_price != null
                                              ? old_meal.new_price
                                              : 0
                                          }}
                                          {{
                                            old_meal.new_price != null
                                              ? restaurant.settings.price
                                              : ""
                                          }}
                                        </span>
                                      </span>
                                      <span
                                        style="
                                          color: #7e7a7a;
                                          font-size: 13px;
                                          padding-top: 3px;
                                        "
                                        >{{ old_meal.name }}</span
                                      >
                                    </span>
                                  </span>
                                  <div class="qty-controls" style="width: 30%">
                                    <a
                                      @click.prevent="
                                        qty(old_meal, 'minus', item.date, 'shift_two')
                                      "
                                      class="qty-btn mr-5"
                                    >
                                      <span
                                        class="qty-minus"
                                        style="padding: 0 12px 3px; font-size: 39px"
                                        >-</span
                                      >
                                    </a>
                                    <span> {{ old_meal.qty }} </span>
                                    <a
                                      @click.prevent="
                                        qty(old_meal, 'plus', item.date, 'shift_two')
                                      "
                                      class="qty-btn ml-5"
                                    >
                                      <span
                                        class="qty-plus"
                                        style="padding: 0 10px; font-size: 27px"
                                        >+</span
                                      >
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div v-if="user"></div>
                              <div
                                v-if="buyingList[item.date].shifts.shift_one.length > 0"
                                class="text-center mt-2 w-100"
                              >
                                <button
                                  class="px-8 py-1 primary confirm-btn"
                                  @click.prevent="
                                    sentOrder(buyingList[item.date], item.date, index)
                                  "
                                >
                                  {{ $t("confirm") }}
                                  <span v-if="total[item.date]"
                                    >{{ formatPrice(total[item.date]) }}
                                    {{
                                      $store.state.company
                                        ? $store.state.company.restaurant.settings.price
                                        : ""
                                    }}</span
                                  >
                                </button>
                              </div>
                            </div>
                            <p
                              v-else-if="
                                !allOrderOrders[item.date] && buyList.length == 0
                              "
                              class="cart-empty-msg text-center"
                            >
                              {{ $t("you_have_not_selected_any_item") }} <br />
                              {{ $t("when_selected_your_order_appears_here") }}
                            </p>
                            <p
                              v-if="
                                buyingList[item.date] &&
                                buyingList[item.date].shifts.shift_one.length == 0
                              "
                              class="cart-empty-msg text-center"
                            >
                              {{ $t("you_have_not_selected_any_item") }} <br />
                              {{ $t("when_selected_your_order_appears_here") }}
                            </p>
                          </section>
                        </v-card-title>
                      </v-card>
                    </template>
                  </template>
                </v-data-table>
              </template>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>

    <global-dialog-card v-model="dialog1" :title="$t('time_of_delivery')">
      <v-row>
        <v-col cols="6">
          <autocomplete
            :items="setHoures"
            item-value="val"
            v-model="delivery_from"
            label="Сати"
          >
          </autocomplete>
        </v-col>
        <v-col cols="6">
          <autocomplete
            :items="setMinutes"
            item-value="val"
            v-model="delivery_to"
            :label="$t('minutes')"
          >
          </autocomplete>
        </v-col>
      </v-row>
      <template #actions>
        <primary-button color="success" dark @click="dialog1 = false">
          {{ $t("save") }}
        </primary-button>
      </template>
    </global-dialog-card>

    <global-dialog-card v-model="dialog" :max-width="1200" hide-actions>
      <v-row>
        <v-col cols="12" sm="6">
          <v-img
            :src="
              selectedMeal.image
                ? galleryUrl(selectedMeal.image.name, 'medium', restaurant.id)
                : './media/img/no-image.webp'
            "
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
        <v-col cols="12" sm="6" class="ml-sm-n16 my-sm-2 mt-sm-16">
          <v-row align="end" class="fill-height">
            <v-card elevation="0" class="pa-5">
              <v-card-title>
                <h3>
                  {{ toLatin(selectedMeal.name) }}
                </h3>
              </v-card-title>
              <v-card-text class="mb-4">
                <v-row no-gutters>
                  <template v-for="(eat, i) in selectedMeal.foods">
                    <v-col cols="12" class="font-weight-bold pt-2">
                      <v-row no-gutters justify="space-between">
                        <h3>{{ toLatin(eat.name) }}</h3>
                      </v-row>
                    </v-col>
                    <v-col cols="12">{{ translate(eat.description) }}</v-col>
                  </template>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </global-dialog-card>
  </v-row>
</template>

<script>
import moment from "moment";
import restaurantService from "@/services/restaurant";
import categoryService from "@/services/category";
import companyService from "@/services/company";
import menuService from "@/services/menu";
import userService from "@/services/user";
import orderService from "@/services/order";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  data() {
    return {
      order_success: false,
      edit_user_location: false,
      locations: [],
      selectedDate: {
        name: "rucak",
        date: new Date().toISOString().substr(0, 10),
        shift: {
          text: "1-smena",
          key: "shift_one",
          value: 1,
        },
      },
      menues: [],
      dialog: false,
      dialog1: false,
      selectedMeal: [],
      dayTo: "",
      time: "",
      sati: "",
      delivery_time: {},
      total: {},
      delivery_from: {},
      delivery_to: {},
      index: "",
      newUserLocation: {
        entity_id: this.user ? this.user.id : "",
        coordinates: {
          longitude: "",
          latitude: "",
        },
        entity_type: 3,
        address: "",
      },
      buyList: [],
      allOrderOrders: [],
      allUserLocation: "",
      set_user_location: "",
      buyingList: {},
      categories: "",
      cat: false,
      cate: "",
      countries: "",
      country: "",
      phone_popup: false,
      image_popup: false,
      mealDesc: "",
      mealDate: "",
      buyListItem: "",
      buyListShift: "",
      buyListIndex: "",
      buyListMeal: "",
      noUserRestoran: "",
      editUserLocation: "",
      changedUserLocation: "",
      edit_city: "",
      edit_country: "",
    };
  },
  methods: {
    textLimited(text) {
      if (text.length > 25) {
        return text.substring(0, 25) + "...";
      } else {
        return text;
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    changePhone() {
      userService
        .changeUserPhone(this.user)
        .then(({ data }) => {
          if (data) {
            this.phone_popup = false;
            this.showSuccessSnackbar(this.$t("phone_changed_successfully"));
          }
        })
        .catch((error) => {
          if (
            error.response?.data.status == "failed" &&
            error.response?.data.message == "Nema korisnika"
          ) {
            this.phone_popup = false;
            this.showErrorSnackbar(error.response.data.message);
          } else {
            this.showErrorSnackbar(error, this.$t("error_changing_phone"));
          }
        });
    },
    openImage(meal, date, item, shift, index) {
      this.mealDesc = meal;
      this.mealDate = date;
      this.buyListShift = shift;
      this.buyListItem = item;
      this.buyListIndex = index;
      if (this.buyingList[item.date] && this.buyingList[item.date].shifts[shift][index]) {
        meal.qty = this.buyingList[item.date].shifts[shift][index].qty;
      } else {
        meal.qty = 0;
      }
      this.buyListMeal = meal;
      this.image_popup = true;
    },
    countryCity() {
      restaurantService
        .getCountriesAll()
        .then(({ data }) => {
          this.countries = data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_countries"));
        });
    },
    changeCategory(cate) {
      this.cat = true;
      this.cate = cate;
    },
    getCategories() {
      let config = {
        headers: {
          restaurant: this.restaurant.id,
        },
      };

      categoryService
        .getCategoriesGuest(config)
        .then((res) => {
          res.data.filter((item) => {
            if (item.food.length) {
              item.food.filter((fo) => {
                fo.food_id = fo.id;
              });
            }
          });
          this.categories = res.data;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_categories"));
        });
    },
    setEditLocation() {
      let data = {};
      data["address"] = this.changedUserLocation;
      data["id"] = this.editUserLocation.id;
      data["city_id"] = this.edit_city;
      userService.editUserLocation(data).then(({ data }) => {
        if (data) {
          this.edit_user_location = false;
          this.allUserLocation.filter((location) => {
            if (location.id == data.data.id) {
              location.address = data.data.address;
              location.city_id = data.data.city_id;
            }
          });
        }
        this.$forceUpdate();
      });
    },
    removeFromList(list, date, shift) {
      let indexOfObject = this.buyingList[date].shifts[shift].findIndex((object) => {
        return object.meal_id === list.meal_id;
      });
      this.$delete(this.buyingList[date].shifts[shift], date, 1);
      this.buyingList[date].shifts[shift].splice(indexOfObject, 1);
      this.total[date] = 0;
      for (let i in this.buyingList[date].shifts) {
        this.buyingList[date].shifts[i].filter((it) => {
          this.total[date] += it.qty * Number(it.price);
        });
      }

      if (list.order_id) {
        orderService.removeFromOrderList(list);
      }
      this.$forceUpdate();
    },
    qty(meal, type, date, shift) {
      meal.price = Number(meal.price);
      if (type == "minus") {
        if (meal.qty == 0 || meal.quantity == 0) {
          meal.quantity = 0;
          meal.qty = 0;
        } else if (meal.qty == -1 || meal.quantity == -1) {
          meal.quantity = 0;
          meal.qty = 0;
          this.removeFromList(meal, date, shift);
        } else {
          meal.quantity = meal.quantity - 1;
          meal.qty = meal.qty - 1;
        }
        if (meal.qty == 0) {
          this.removeFromList(meal, date, shift);
        }
      }
      if (type == "plus") {
        if (meal.qty == 0 || meal.quantity == 0) {
          meal.quantity = meal.quantity + 1;
          meal.qty = meal.qty + 1;
        } else if (meal.qty == -1 || meal.quantity == -1) {
          meal.quantity = 0;
          meal.qty = 0;
        } else {
          meal.quantity = meal.quantity + 1;
          meal.qty = meal.qty + 1;
        }
      }

      if (this.buyingList[date]) {
        this.total[date] = 0;
        for (let i in this.buyingList[date].shifts)
          this.buyingList[date].shifts[i].filter((it) => {
            this.total[date] += it.qty * Number(it.price);
          });
      }

      this.$forceUpdate();
    },
    addToBuyList(meal, item, shift, index) {
      if (
        this.buyingList[item.date] &&
        this.buyingList[item.date].shifts[shift].find((i, index) =>
          [i.id ? i.id : i.meal_id].includes(meal.id)
        )
      ) {
        this.buyingList[item.date].shifts[shift].filter((bu, index1) => {
          if (bu.id && bu.id == meal.id) {
            if (this.mealDesc.qty) {
              this.buyingList[item.date].shifts[shift][index1].qty = this.mealDesc.qty;
            } else {
              this.buyingList[item.date].shifts[shift][index1].qty++;
            }
          } else if (bu.meal_id == meal.id) {
            if (this.mealDesc.qty) {
              this.buyingList[item.date].shifts[shift][index1].qty = this.mealDesc.qty;
            } else {
              this.buyingList[item.date].shifts[shift][index1].qty++;
            }
            // this.buyingList[item.date].shifts[shift][index1].qty++
          }
        });
        this.total[item.date] = 0;
        this.buyingList[item.date].shifts.shift_one.filter((it) => {
          this.total[item.date] += it.qty * Number(it.price);
        });
        this.buyingList[item.date].shifts.shift_two.filter((it) => {
          this.total[item.date] += it.qty * Number(it.price);
        });
        this.$forceUpdate();
      } else {
        let data = {};
        data["user_id"] = this.user ? this.user.id : "";
        data["date"] = item.date;
        data["type"] = "ручак";
        data["qty"] = 1;
        data["name"] = meal.name;
        data["id"] = meal.id;
        data["price"] = meal.price;
        data["shifts"] = {};
        data["shifts"][shift] = {};
        data["shifts"][shift]["meals"] = [];
        data["shifts"][shift]["meals"].push({
          meal: meal,
          qty: 1,
        });

        if (!this.buyingList[item.date]) {
          this.buyingList[item.date] = {};
          this.buyingList[item.date]["date"] = item.date;
          this.buyingList[item.date]["type"] = "ручак";
          this.buyingList[item.date]["delivery_time"] = moment().format("HH:mm");
          this.buyingList[item.date]["location"] = {};
          this.buyingList[item.date]["location"]["address"] = this.restaurant.address;
          this.buyingList[item.date]["location"]["id"] = this.newUserLocation.entity_type;
          this.buyingList[item.date]["location"]["longitude"] = "";
          this.buyingList[item.date]["location"]["latitude"] = "";
          this.buyingList[item.date]["user_id"] = this.user ? this.user.id : "";
          this.buyingList[item.date]["shifts"] = {};
          this.buyingList[item.date]["shifts"]["shift_one"] = [];
          this.buyingList[item.date]["shifts"]["shift_two"] = [];
          this.buyingList[item.date]["shifts"]["shift_three"] = [];
          this.buyingList[item.date]["delivery_type"] = true;

          this.buyingList[item.date]["shifts"][shift].push({
            meal_id: meal.id,
            food_id: meal.food_id ? meal.food_id : "",
            name: meal.name,
            price: Number(meal.price),
            qty: meal.qty ? meal.qty : 1,
            new_price: Number(meal.price),
          });
        } else {
          this.buyingList[item.date].shifts[shift].push({
            meal_id: meal.id,
            food_id: meal.food_id ? meal.food_id : "",
            name: meal.name,
            price: Number(meal.price),
            qty: meal.qty ? meal.qty : 1,
            new_price: Number(meal.price),
          });
        }
        this.total[item.date] = 0;
        for (let i in this.buyingList[item.date].shifts) {
          this.buyingList[item.date].shifts[i].filter((it) => {
            this.total[item.date] += it.qty * Number(it.price);
          });
        }
        this.$forceUpdate();
      }
      this.image_popup = false;
    },
    sentOrder(order, date, index) {
      orderService
        .createGuestOrders(this.buyingList[date])
        .then(({ data }) => {
          if (data) {
            this.order_success = true;
            setTimeout(() => {
              this.order_success = false;
            }, 3000);
            // this.oldOrders()
            this.buyingList[date].shifts.shift_one = [];
            this.payReserved(data);
          }
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_creating_order"));
        });
    },
    payReserved(reservedMeal) {
      orderService
        .payGuest({
          state: "payed",
          orders: reservedMeal,
        })
        .then((res) => {
          this.payment.text = "Успјешно испоручено";
          this.payment.color = "success";
        })
        .catch((err) => {
          this.payment.text = "Грешка, молим Вас покушајте поново";
          this.payment.color = "error";
        })
        .finally(() => {
          this.payment.status = true;
          this.$forceUpdate();
        });
    },
    rowClass(item) {
      var rowClass = "myclass";
      return rowClass;
    },
    selectRes(res = null) {
      if (res == null && this.restaurant && this.user.type == "guest") {
        userService
          .chooseRestaurant(this.user.id, this.restaurant.id)
          .then(({ data }) => {});
      } else {
        if (res && this.user.type == "guest") {
          userService.chooseRestaurant(this.user.id, res.id);
        }
      }
    },
    locatorButtonPressed() {
      navigator.geolocation.getCurrentPosition(
        (position) => {},
        (error) => {
          console.warn(error.message);
        }
      );
    },
    getUserLocation() {
      this.set_user_location = {};
      userService
        .getUserLocation(this.user ? this.user.id : "")
        .then(({ data }) => {
          this.set_user_location = data.current_location;
          this.$delete(data.data, "data.data");
          let podaci = [];
          data.data.filter((item) => {
            podaci.push({
              id: item.id,
              address: item.address,
              entity_id: item.entity_id,
              city_id: item.city_id,
              country_id: item.city.country_id,
            });
          });
          this.allUserLocation = podaci;
          this.newUserLocation.entity_id = data.data.entity_id;
          this.newUserLocation.coordinates.longitude = "";
          this.newUserLocation.coordinates.latitude = "";
          this.newUserLocation.entity_type = data.data.entity_type;
          this.newUserLocation.address = data.data.address;
        })
        .catch((error) => {
          if (
            error.response.data.status == "failed" &&
            error.response.data.message == "Korisnik nema lokaciju"
          ) {
          }
        });
    },
    getDate(setLimitDay, setLimitHour) {
      let orderDay;

      // trenutni dan manji od setovanog dana
      if (moment().format("E") < setLimitDay) {
        orderDay = moment().startOf("isoWeek").add(1, "week"); // Prvi ponedeljak
      }
      // trenutno dan jednak setovanom danu
      else if (moment().format("E") == setLimitDay) {
        // setovani sat manji od trenutnog sata
        if (setLimitHour < moment().format("H")) {
          orderDay = moment().startOf("isoWeek").add(2, "week"); // Drugi ponedeljak
        }
        // setovani sat jednak trenutnom satu
        else if (setLimitHour == moment().format("H")) {
          // trenutni minuti veci od setvanih (0)
          if (moment().format("m") == 0) {
            orderDay = moment().startOf("isoWeek").add(1, "week"); // Prvi ponedeljak
          } else {
            orderDay = moment().startOf("isoWeek").add(2, "week"); // Drugi ponedeljak
          }
        }
        // setovan sat veci od trenutnog
        else {
          orderDay = moment().startOf("isoWeek").add(1, "week"); // Prvi ponedeljak
        }
      }
      // trenutni dan veci od setovanog
      else {
        orderDay = moment().startOf("isoWeek").add(2, "week"); // Drugi ponedeljak
      }
      orderDay.set("hour", setLimitHour);
      orderDay.set("minute", 0);

      return orderDay;
    },
    async getMenues() {
      if (this.selectedDate.name) {
        let newDate = moment(this.selectedDate.date).add(0, "days").format("YYYY-MM-DD");
        await menuService
          .getGuestWebAppMenu({
            from: this.selectedDate.date,
            to: newDate,
            type: this.selectedDate.name,
            user: this.user.id,
            company: this.company?.id || null,
            restaurant: this.restaurant.id,
          })
          .then((res) => {
            res.data.forEach((menu, i) => {
              let check = menu.meals.find(
                (i) => i.shift_one || i.shift_two || i.shift_three
              );

              if (!this.set_user_location[menu.date]) {
                this.set_user_location[menu.date] = {
                  id: 0,
                  address: "",
                  entity_id: "",
                };
              }

              if (check) {
                let dan = this.restaurant.settings.guest.dan;
                let location = [
                  this.$store.state.company.id,
                  this.$store.state.company.name,
                ];
                let shiftOne = this.company.shift_one;
                let shiftTwo = this.company.shift_one;
                let shiftThree = this.company.shift_one;
                let rokDana = this.company.restaurant.settings.guest.rok_dana;
                let orderBefore = this.company.restaurant.settings.guest.order_before;
                let rokSati = this.company.restaurant.settings.guest.rok_sati;

                let datum = moment(this.selectedDate.date).add(dan, "days");
                let meal =
                  menu.type === "rucak"
                    ? menu.meals.find((meal) => meal.orders.length)
                    : null;

                this.menues.push({
                  id: meal ? meal.orders[0].id : null,
                  location: location,
                  name:
                    this.convertNameOfDay(moment(menu.date).format("dddd")) +
                    " " +
                    moment(menu.date).format("DD.MM.YYYY"),
                  shift_one: menu.meals
                    .filter((i) => i[this.findShift(shiftOne)])
                    .map((i) => {
                      if (
                        i &&
                        (!i.orders.length || !i.orders.find((i) => i.shift === "1-smena"))
                      )
                        i.orders.push({ quantity: 0, shift: "1-smena" });
                      i.orders.find(
                        (i) => i.shift === "1-smena"
                      ).orginal_qty = i.orders.find((i) => i.shift === "1-smena").quantity
                        ? i.orders.find((i) => i.shift === "1-smena").quantity
                        : 0;
                      i.orders.find(
                        (i) => i.shift === "1-smena"
                      ).quantity_payed = i.orders.find((i) => i.shift === "1-smena")
                        .quantity_payed
                        ? i.orders.find((i) => i.shift === "1-smena").quantity_payed
                        : 0;
                      return i;
                    }),
                  shift_two: menu.meals
                    .filter((i) => i[this.findShift(shiftTwo)])
                    .map((i) => {
                      if (
                        i &&
                        (!i.orders.length || !i.orders.find((i) => i.shift === "2-smena"))
                      )
                        i.orders.push({ quantity: 0, shift: "2-smena" });
                      i.orders.find(
                        (i) => i.shift === "2-smena"
                      ).orginal_qty = i.orders.find((i) => i.shift === "2-smena").quantity
                        ? i.orders.find((i) => i.shift === "2-smena").quantity
                        : 0;
                      i.orders.find(
                        (i) => i.shift === "2-smena"
                      ).quantity_payed = i.orders.find((i) => i.shift === "2-smena")
                        .quantity_payed
                        ? i.orders.find((i) => i.shift === "2-smena").quantity_payed
                        : 0;
                      return i;
                    }),
                  shift_three: menu.meals
                    .filter((i) => i[this.findShift(shiftThree)])
                    .map((i) => {
                      if (
                        i &&
                        (!i.orders.length || !i.orders.find((i) => i.shift === "3-smena"))
                      )
                        i.orders.push({ quantity: 0, shift: "3-smena" });
                      i.orders.find(
                        (i) => i.shift === "3-smena"
                      ).orginal_qty = i.orders.find((i) => i.shift === "3-smena").quantity
                        ? i.orders.find((i) => i.shift === "3-smena").quantity
                        : 0;
                      i.orders.find(
                        (i) => i.shift === "3-smena"
                      ).quantity_payed = i.orders.find((i) => i.shift === "3-smena")
                        .quantity_payed
                        ? i.orders.find((i) => i.shift === "3-smena").quantity_payed
                        : 0;
                      return i;
                    }),
                  // poredi zadati dan sa trenutnim danom u meniju
                  disabled: rokDana
                    ? moment(this.selectedDate.date).add(Number(orderBefore), "days") >
                      moment(menu.date)
                      ? true
                      : false
                    : rokSati
                    ? datum >= moment(menu.date)
                      ? false
                      : false
                    : false,
                  // sto se trazi ID na ovaj nacin
                  test: meal ? meal.id + "_" + meal.orders[0].shift : null,
                  date: menu.date,
                });

                if (this.user && this.user.type === "company") {
                  this.menues[this.menues.length - 1].shift_three.push({
                    name: "Укупно",
                  });
                  this.menues[this.menues.length - 1].shift_two.push({
                    name: "Укупно",
                  });
                  this.menues[this.menues.length - 1].shift_one.push({
                    name: "Укупно",
                  });
                }
              }
            });
          });

        if (this.user && this.user.is_transferable) {
          let cId = 0;
          cId = this.$store.state.company.parent_id;
          if (!cId) cId = this.$store.state.company.id;
          await companyService.getCompanyList(cId).then((res) => {
            this.locations = res.data;
            this.locations.forEach((item) => {
              if (item[0] === this.$store.state.company.id) this.location = item;
            });
          });
        }
      }
    },
    findShift(num) {
      switch (num) {
        case 1:
          return "shift_one";
        case 2:
          return "shift_two";
        case 3:
          return "shift_three";
      }
    },
    convertNameOfDay(name) {
      switch (name) {
        case "Sunday":
          return "Недјеља";
        case "Monday":
          return "Понедјељак";
        case "Tuesday":
          return "Уторак";
        case "Wednesday":
          return "Сриједа";
        case "Thursday":
          return "Четвртак";
        case "Friday":
          return "Петак";
        case "Saturday":
          return "Субота";
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    editCountries() {
      let cities = "";
      if (this.edit_country) {
        this.countries.filter((county) => {
          if (county.id == this.edit_country) {
            cities = county.city;
          }
        });
      }
      return cities;
    },
    setMinutes() {
      let minutes = [];
      if (this.restaurant) {
        minutes.push(Number(this.restaurant.settings.delivery_to));
        if (this.restaurant.settings.delivery_to1 == "15") {
          minutes.push(15);
        } else if (this.restaurant.settings.delivery_to1 == "30") {
          minutes.push(15, 30);
        } else if (this.restaurant.settings.delivery_to1 == "45") {
          minutes.push(15, 30, 45);
        } else {
          minutes.push(0, 15, 30, 45);
        }
      }

      return minutes;
    },
    setHoures() {
      let hours = [];
      if (this.restaurant) {
        for (
          let i = this.restaurant.settings.delivery_from;
          i <= this.restaurant.settings.delivery_from1;
          i++
        ) {
          hours.push(Number(i));
        }
      }
      return hours;
    },
    checkTime() {
      return moment(this.time, "HH:mm").isBefore(moment(this.sati, "HH:mm"));
    },
    company() {
      return this.$store.state.company;
    },
    restaurant() {
      if (this.$store.state.restaurant == null && this.$store.state.company == null) {
        restaurantService.getAllRestaurantsPublic();
      } else {
        return this.$store.state.restaurant
          ? this.$store.state.restaurant
          : this.$store.state.company.restaurant;
      }
    },
    headers() {
      let data = [];
      let shift_one = this.$store.state.company.shift_one;
      let shift_two = this.$store.state.company.shift_two;
      let shift_three = this.$store.state.company.shift_three;
      if (shift_one)
        data.push({
          text: "Прва смјена",
          value: "shift_one",
          sortable: false,
          align: "center",
          width: "33%",
        });
      data.push({
        text: "Твоја ордера наруџба",
        value: "korpa",
        sortable: false,
        align: "center",
        width: "15%",
      });

      return data;
    },
  },
  watch: {
    user: {
      handler: function (newValue) {
        if (newValue) {
          this.getMenues();
          this.getUserLocation();
          this.locatorButtonPressed();
          this.selectRes();
          this.getCategories();
          this.countryCity();
          setTimeout(() => {
            let a = false;
            this.menues.filter((menu, index) => {
              if (a) {
                return;
              }
              let brojSati = this.restaurant.settings.guest.broj_sati;
              let rokSati = this.restaurant.settings.guest.rok_sati;
              let rokDana = this.restaurant.settings.guest.rok_dana;
              let dan = this.restaurant.settings.guest.dan;

              let sati = brojSati <= 9 ? +"0" + brojSati : brojSati;

              if (rokSati) {
                let date = this.getDate(dan, sati);
                this.dayTo = moment(date).format("YYYY-MM-DD");

                if (menu.date == moment(date).format("YYYY-MM-DD")) {
                  a = true;
                  const dokle = document.getElementById(index);
                  dokle.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                    inline: "nearest",
                  });
                }
                return;
              }
              if (rokDana) {
                if (menu.disabled == false) {
                  this.dayTo = menu.date;
                  a = true;
                  const dokle = document.getElementById(index);
                  dokle.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                    inline: "nearest",
                  });
                }
              }

              if (menu.disabled == false) {
                this.dayTo = menu.date;
                a = true;
                const dokle = document.getElementById(index);
                dokle.scrollIntoView({
                  block: "start",
                  behavior: "smooth",
                  inline: "nearest",
                });
              }
            });
          }, 1200);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.active-category {
  color: #ff5722 !important;
  font-weight: 700 !important;
}
.sidebar__widget {
  position: sticky;
  top: 136px;
  height: 20px;
}
.cat_link:hover {
  background: rgba(207, 207, 207, 0.24);
}
/* Repeated patterns extracted from inline styles */
.guest-input {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.26);
  padding: 8px 10px;
  border-radius: 7px;
}
.category-link {
  padding: 11px 20px;
  display: block;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 13px;
  color: #595959;
}
.category-nav {
  width: 95%;
  margin: 5px auto 0;
  padding: 20px 0;
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12);
}
.meal-card-container {
  padding: 0 7px 7px;
  margin-bottom: 7px;
}
.meal-card {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: 12px;
}
.meal-image-container {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.meal-image {
  cursor: pointer;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  position: absolute;
  left: 0;
  width: 100%;
  background-size: cover;
}
.meal-name-text {
  color: #888888;
  font-weight: 400;
  font-size: 13px;
  line-height: 17px;
}
.order-btn {
  color: #fff;
  text-transform: capitalize;
  font-weight: 400;
  width: 100%;
}
.qty-controls {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qty-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.qty-minus {
  border-radius: 7px;
  color: #ff4c0b;
  background: rgba(251, 109, 59, 0.43);
}
.qty-plus {
  border-radius: 7px;
  color: #06b04d;
  background: rgba(95, 227, 148, 0.6);
}
.cart-item-row {
  width: 100%;
  padding: 0;
  border-bottom: 2px solid rgba(231, 231, 231, 0.56);
}
.cart-item-info {
  font-size: 11px;
  font-weight: 700;
  padding-right: 10px;
  line-height: 13px;
}
.cart-item-price {
  font-weight: 900;
  font-size: 13px;
  line-height: 13px !important;
}
.cart-item-name {
  color: #7e7a7a;
  font-size: 16px;
  padding-top: 3px;
  margin-top: 2px;
}
.cart-empty-msg {
  font-size: 14px;
  font-weight: 300;
}
.image-popup-overlay {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: #fff;
  position: relative;
  z-index: 99999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12);
  margin-top: -35px;
}
.success-image {
  cursor: pointer;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.success-text {
  color: #009924;
  font-weight: 700;
  font-size: 20px;
}
.confirm-btn {
  color: #fff;
  border-radius: 5px;
  font-size: 12px;
  width: 100%;
}
.meal-description {
  font-size: 12px;
  font-weight: 400;
  color: #595959;
}
.price-label {
  font-size: 14px;
  color: #232323;
  font-weight: 900;
  margin-bottom: -7px;
}
.menu-content-wrapper {
  width: 100%;
  margin: -30px auto 0;
  padding: 1px 9px;
}

.theme--light.v-data-table
  > div.v-data-table__wrapper
  > table
  > tbody
  > tr.myclass:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  vertical-align: unset !important;
}
.home-page .v-data-table__mobile-row {
  display: flex !important;
  flex-direction: column !important;
}
tbody tr:nth-child(even):hover {
  background-color: transparent !important;
}
tbody td.text-center:nth-child(n + 2) {
  vertical-align: center;
}
tbody td.text-right {
  padding: 0px !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: white !important;
}

.v-input--selection-controls.v-input {
  margin-top: 0;
}

td.text-center {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
</style>

<style>
.theme--light.v-data-table
  > div.v-data-table__wrapper
  > table
  > tbody
  > tr.myclass:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: none;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  box-shadow: none;
  background: none;
}
#sticky-div {
  position: sticky;
  bottom: 0;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.87);
}
div.v-input--selection-controls__input {
  margin-top: -10px !important;
}
.theme--light.v-data-table
  > div.v-data-table__wrapper
  > table
  > tbody
  > tr.myclass:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  vertical-align: top !important;
}
.v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: clip;
}
.relative {
  position: relative;
  width: max-content;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  color: #5d3f27;
  font-size: 18px;
  width: 70%;
  text-align: left;
  cursor: pointer;
}
.v-application--is-ltr .v-input--selection-controls__input {
  display: none;
}
.v-input--selection-controls.v-input {
  margin-top: 10px;
  margin-left: 5px;
}
.transfer-lista {
  width: 30%;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .home-page {
    padding-top: 0 !important;
  }
  .transfer-lista {
    width: 80%;
  }
}
</style>
